import { render, staticRenderFns } from "./HomePresentation.vue?vue&type=template&id=f3debdb4&scoped=true"
import script from "./HomePresentation.vue?vue&type=script&lang=js"
export * from "./HomePresentation.vue?vue&type=script&lang=js"
import style0 from "./HomePresentation.vue?vue&type=style&index=0&id=f3debdb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../app/browser@vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3debdb4",
  null
  
)

export default component.exports